import React from 'react';
const AutoCaptureCamera = (props) => null;
export default AutoCaptureCamera;
